
































































































































































































import { $store } from "@/store";
import {
  LayoutInsert,
  layoutInsertTextContentAlignments,
  layoutInsertTypes,
} from "@/store/layout/types";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class LayoutInsertDetails extends Vue {
  get pageWidth() {
    return $store.appearance.pdfViewerPageWidth;
  }

  get pageScale() {
    return this.currentPage
      ? this.pageWidth /
          $store.layoutSources.getPageMetadata(this.currentPage).width
      : 1;
  }

  get toolbarHeight() {
    return $store.appearance.PDFVIEWERTOOLBAR_HEIGHT - 60;
  }

  get currentPage() {
    return $store.wizard.layoutPage;
  }

  get totalPages() {
    return $store.layoutSources.layoutSource?.metadata.numberOfPages || 0;
  }

  get insertTypes() {
    return layoutInsertTypes;
  }

  get insertTextContentAlignments() {
    return layoutInsertTextContentAlignments;
  }

  get insert() {
    if (typeof this.selectedInsert == "number") {
      return $store.layouts.getInsert(this.selectedInsert);
    }
    return null;
  }

  get selectedInsert() {
    return $store.wizard.selectedInsert;
  }

  get insertListHeight() {
    return `${$store.appearance.PDFVIEWERTOOLBAR_HEIGHT - 70}px`;
  }

  get predefinedInsert() {
    return $store.wizardInstances.wizardInstance?.config.layout?.predefinedInserts?.find(
      (insert) => insert.ref === this.insert?.ref
    );
  }

  get isRefEditable() {
    return !this.predefinedInsert?.ref;
  }

  get isTypeEditable() {
    return !this.predefinedInsert?.type;
  }

  get isPageEditable() {
    return typeof this.predefinedInsert?.page !== "number";
  }

  get isTextContentFontSizeEditable() {
    return typeof this.predefinedInsert?.textContent?.fontSize !== "number";
  }

  get isTextContentAlignmentEditable() {
    return !this.predefinedInsert?.textContent?.alignment;
  }

  get isTextContentContentEditable() {
    return (
      !this.predefinedInsert?.textContent?.content ||
      this.predefinedInsert?.textContent?.content.length == 0
    );
  }

  get scrollElem() {
    return document.getElementById("pdfviewer-container");
  }

  handlePageInputBlur(evt: FocusEvent) {
    if (this.insert) {
      const elem = evt.target as HTMLInputElement;
      const value = Number(elem.value);
      if (value != this.currentPage && value > 0 && value <= this.totalPages) {
        this.insert.page = value;
        if (this.scrollElem && this.currentPage != this.insert.page)
          this.scrollElem.scrollTop = 0;
        $store.wizard.layoutPage = this.insert.page;
        setTimeout(() => {
          document
            .getElementById((this.insert as LayoutInsert).ref)
            ?.scrollIntoView();
        }, 100);
      } else {
        elem.textContent = this.insert.page.toString();
        elem.value = this.insert.page.toString();
      }
    }
  }
}
